// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== SAVED FEED CONTAINER ==================== */

.uasc-saved-feed-container {
  position: relative;
  width: 95%;
  height: auto;
  padding: 1rem;
  box-sizing: border-box;
  max-width: 1500px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 2rem;
  border-radius: 10px;
  margin-bottom: 3rem;
  overflow: visible;
  background: var(--card-bg, rgb(4, 4, 4));
  border: 1px solid var(--border-color, rgb(52, 51, 51));
  margin-left: 12px;
}

/* ==================== POST WRAPPER ==================== */

.uasc-post-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-bottom: 1.5rem;
}

/* ==================== HEADER SECTION (BLACK BACKGROUND) ==================== */

.uasc-post-header-section {
  width: 100%;
  background: #000;
  border-radius: 10px 10px 0 0;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-bottom: none;
}

/* ==================== POST ID ==================== */

.uasc-post-id {
  width: 100%;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.uasc-post-id-link {
  color: white;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;
}

.uasc-post-id-link:hover {
  color: #ffed4e;
  text-decoration: underline;
}

/* ==================== USER INFO WRAPPER ==================== */

.uasc-user-info-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.75rem;
  width: 100%;
}

.uasc-user-avatar-wrapper {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
}

.uasc-user-details {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* ==================== USER NAME ROW ==================== */

.uasc-user-name-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.uasc-user-name-link {
  text-decoration: none;
  color: white;
  transition: color 0.3s ease;
}

.uasc-user-name-link:hover {
  color: #4a9eff;
}

/* ==================== PROFILE BADGE (HIGHLIGHTED) ==================== */

.uasc-profile-badge {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.25), rgba(255, 165, 0, 0.25));
  border: 1.5px solid rgba(255, 215, 0, 0.5);
  border-radius: 20px;
  padding: 0.35rem 1rem;
  box-shadow: 0 2px 10px rgba(255, 215, 0, 0.2);
  transition: all 0.3s ease;
}

.uasc-profile-badge:hover {
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.35), rgba(255, 165, 0, 0.35));
  box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);
  transform: translateY(-2px);
}

.uasc-profile-link {
  text-decoration: none;
  color: #ffd700;
  font-size: 0.9rem;
  font-weight: 700;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  letter-spacing: 0.5px;
}

/* ==================== TIMESTAMP ROW ==================== */

.uasc-timestamp-row {
  display: flex;
  align-items: center;
  width: 100%;
}

.uasc-timestamp {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.875rem;
  font-weight: 400;
}

/* ==================== SAVED FEED CARD ==================== */

.uasc-saved-feed-card {
  width: 100%;
  height: auto;
  border-radius: 0 0 10px 10px;
  background: none;
  box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.1);
  /* border: 1px solid rgba(255, 255, 255, 0.1); */
  border-top: none;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* ==================== POST DESCRIPTION ==================== */

.uasc-post-description {
  width: 100%;
  padding: 0.5rem;
}

.uasc-post-description .text-label {
  color: white;
  line-height: 1.6;
}

/* ==================== SAVED FEED MEDIA ==================== */

.uasc-saved-feed-media {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.uasc-feed-media-container {
  width: 100%;
  height: auto;
  border-radius: 12px;
  overflow: hidden;
}

.saved-media-img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
}

/* ==================== POST LOCATION ==================== */

.uasc-post-location {
  width: 100%;
  padding: 0.75rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 0.5rem;
}

.uasc-location-link {
  color: #4a9eff;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  transition: color 0.3s ease;
}

.uasc-location-link:hover {
  color: #74b9ff;
  text-decoration: underline;
}

/* ==================== LOADING & EMPTY STATES ==================== */

.uasc-loading {
  width: 100%;
  padding: 3rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
}

.uasc-no-posts {
  width: 100%;
  padding: 3rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
}

/* ==================== RESPONSIVE: TABLET ==================== */

@media (max-width: 1024px) {
  .uasc-saved-feed-container {
    padding: 0.75rem;
    gap: 1.5rem;
  }

  .uasc-post-header-section {
    padding: 0.875rem;
  }

  .uasc-saved-feed-card {
    padding: 0.875rem;
  }
}

@media (max-width: 768px) {
  .uasc-saved-feed-container {
    padding: 0.5rem;
    gap: 1rem;
    margin-bottom: 2rem;
  }

  .uasc-post-header-section {
    padding: 0.75rem;
    gap: 0.75rem;
  }

  .uasc-user-name-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .uasc-profile-badge {
    padding: 0.3rem 0.8rem;
  }

  .uasc-saved-feed-card {
    padding: 0.75rem;
  }

  .uasc-post-id-link {
    font-size: 0.9rem;
  }

  .uasc-timestamp {
    font-size: 0.8rem;
  }
}

/* ==================== RESPONSIVE: MOBILE ==================== */

@media (max-width: 480px) {
  .uasc-saved-feed-container {
    padding: 0.5rem;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
  }

  .uasc-post-wrapper {
    margin-bottom: 1rem;
  }

  .uasc-post-header-section {
    padding: 0.5rem;
    gap: 0.5rem;
  }

  .uasc-user-avatar-wrapper {
    width: 40px;
    height: 40px;
  }

  .uasc-user-name-row {
    gap: 0.4rem;
  }

  .uasc-profile-badge {
    padding: 0.25rem 0.6rem;
    font-size: 0.8rem;
  }

  .uasc-saved-feed-card {
    padding: 0.5rem;
  }

  .uasc-post-description {
    padding: 0.25rem;
  }

  .uasc-post-id-link {
    font-size: 0.85rem;
  }

  .uasc-timestamp {
    font-size: 0.75rem;
  }

  .uasc-location-link {
    font-size: 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Styles/UASavedContent.css"],"names":[],"mappings":"AAAA,mEAAmE;;AAEnE;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;EACxC,sDAAsD;EACtD,iBAAiB;AACnB;;AAEA,2DAA2D;;AAE3D;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,qBAAqB;AACvB;;AAEA,gFAAgF;;AAEhF;EACE,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA,sDAAsD;;AAEtD;EACE,WAAW;EACX,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,gEAAgE;;AAEhE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,4DAA4D;;AAE5D;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,0EAA0E;;AAE1E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qFAAqF;EACrF,0CAA0C;EAC1C,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,qFAAqF;EACrF,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA,4DAA4D;;AAE5D;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,8DAA8D;;AAE9D;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,0CAA0C;EAC1C,gDAAgD;EAChD,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,+DAA+D;;AAE/D;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,+DAA+D;;AAE/D;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,4DAA4D;;AAE5D;EACE,WAAW;EACX,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,qEAAqE;;AAErE;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,iEAAiE;;AAEjE;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,iEAAiE;;AAEjE;EACE;IACE,eAAe;IACf,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* ==================== SAVED FEED CONTAINER ==================== */\n\n.uasc-saved-feed-container {\n  position: relative;\n  width: 95%;\n  height: auto;\n  padding: 1rem;\n  box-sizing: border-box;\n  max-width: 1500px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 2rem;\n  border-radius: 10px;\n  margin-bottom: 3rem;\n  overflow: visible;\n  background: var(--card-bg, rgb(4, 4, 4));\n  border: 1px solid var(--border-color, rgb(52, 51, 51));\n  margin-left: 12px;\n}\n\n/* ==================== POST WRAPPER ==================== */\n\n.uasc-post-wrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  margin-bottom: 1.5rem;\n}\n\n/* ==================== HEADER SECTION (BLACK BACKGROUND) ==================== */\n\n.uasc-post-header-section {\n  width: 100%;\n  background: #000;\n  border-radius: 10px 10px 0 0;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  border-bottom: none;\n}\n\n/* ==================== POST ID ==================== */\n\n.uasc-post-id {\n  width: 100%;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.uasc-post-id-link {\n  color: white;\n  text-decoration: none;\n  font-size: 1rem;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  transition: color 0.3s ease;\n}\n\n.uasc-post-id-link:hover {\n  color: #ffed4e;\n  text-decoration: underline;\n}\n\n/* ==================== USER INFO WRAPPER ==================== */\n\n.uasc-user-info-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.uasc-user-avatar-wrapper {\n  width: 50px;\n  height: 50px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  overflow: hidden;\n}\n\n.uasc-user-details {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n/* ==================== USER NAME ROW ==================== */\n\n.uasc-user-name-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.uasc-user-name-link {\n  text-decoration: none;\n  color: white;\n  transition: color 0.3s ease;\n}\n\n.uasc-user-name-link:hover {\n  color: #4a9eff;\n}\n\n/* ==================== PROFILE BADGE (HIGHLIGHTED) ==================== */\n\n.uasc-profile-badge {\n  display: inline-flex;\n  align-items: center;\n  background: linear-gradient(135deg, rgba(255, 215, 0, 0.25), rgba(255, 165, 0, 0.25));\n  border: 1.5px solid rgba(255, 215, 0, 0.5);\n  border-radius: 20px;\n  padding: 0.35rem 1rem;\n  box-shadow: 0 2px 10px rgba(255, 215, 0, 0.2);\n  transition: all 0.3s ease;\n}\n\n.uasc-profile-badge:hover {\n  background: linear-gradient(135deg, rgba(255, 215, 0, 0.35), rgba(255, 165, 0, 0.35));\n  box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);\n  transform: translateY(-2px);\n}\n\n.uasc-profile-link {\n  text-decoration: none;\n  color: #ffd700;\n  font-size: 0.9rem;\n  font-weight: 700;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);\n  letter-spacing: 0.5px;\n}\n\n/* ==================== TIMESTAMP ROW ==================== */\n\n.uasc-timestamp-row {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.uasc-timestamp {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.875rem;\n  font-weight: 400;\n}\n\n/* ==================== SAVED FEED CARD ==================== */\n\n.uasc-saved-feed-card {\n  width: 100%;\n  height: auto;\n  border-radius: 0 0 10px 10px;\n  background: none;\n  box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.1);\n  /* border: 1px solid rgba(255, 255, 255, 0.1); */\n  border-top: none;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n/* ==================== POST DESCRIPTION ==================== */\n\n.uasc-post-description {\n  width: 100%;\n  padding: 0.5rem;\n}\n\n.uasc-post-description .text-label {\n  color: white;\n  line-height: 1.6;\n}\n\n/* ==================== SAVED FEED MEDIA ==================== */\n\n.uasc-saved-feed-media {\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.uasc-feed-media-container {\n  width: 100%;\n  height: auto;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.saved-media-img {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n/* ==================== POST LOCATION ==================== */\n\n.uasc-post-location {\n  width: 100%;\n  padding: 0.75rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  margin-top: 0.5rem;\n}\n\n.uasc-location-link {\n  color: #4a9eff;\n  text-decoration: none;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.uasc-location-link:hover {\n  color: #74b9ff;\n  text-decoration: underline;\n}\n\n/* ==================== LOADING & EMPTY STATES ==================== */\n\n.uasc-loading {\n  width: 100%;\n  padding: 3rem;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.uasc-no-posts {\n  width: 100%;\n  padding: 3rem;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n/* ==================== RESPONSIVE: TABLET ==================== */\n\n@media (max-width: 1024px) {\n  .uasc-saved-feed-container {\n    padding: 0.75rem;\n    gap: 1.5rem;\n  }\n\n  .uasc-post-header-section {\n    padding: 0.875rem;\n  }\n\n  .uasc-saved-feed-card {\n    padding: 0.875rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .uasc-saved-feed-container {\n    padding: 0.5rem;\n    gap: 1rem;\n    margin-bottom: 2rem;\n  }\n\n  .uasc-post-header-section {\n    padding: 0.75rem;\n    gap: 0.75rem;\n  }\n\n  .uasc-user-name-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .uasc-profile-badge {\n    padding: 0.3rem 0.8rem;\n  }\n\n  .uasc-saved-feed-card {\n    padding: 0.75rem;\n  }\n\n  .uasc-post-id-link {\n    font-size: 0.9rem;\n  }\n\n  .uasc-timestamp {\n    font-size: 0.8rem;\n  }\n}\n\n/* ==================== RESPONSIVE: MOBILE ==================== */\n\n@media (max-width: 480px) {\n  .uasc-saved-feed-container {\n    padding: 0.5rem;\n    gap: 0.75rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .uasc-post-wrapper {\n    margin-bottom: 1rem;\n  }\n\n  .uasc-post-header-section {\n    padding: 0.5rem;\n    gap: 0.5rem;\n  }\n\n  .uasc-user-avatar-wrapper {\n    width: 40px;\n    height: 40px;\n  }\n\n  .uasc-user-name-row {\n    gap: 0.4rem;\n  }\n\n  .uasc-profile-badge {\n    padding: 0.25rem 0.6rem;\n    font-size: 0.8rem;\n  }\n\n  .uasc-saved-feed-card {\n    padding: 0.5rem;\n  }\n\n  .uasc-post-description {\n    padding: 0.25rem;\n  }\n\n  .uasc-post-id-link {\n    font-size: 0.85rem;\n  }\n\n  .uasc-timestamp {\n    font-size: 0.75rem;\n  }\n\n  .uasc-location-link {\n    font-size: 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
